import React from 'react';
import { styled, Typography } from '@mui/material';
import Symbol from 'components/Symbol';

const Hint = styled('div', {
    shouldForwardProp: prop => prop !== '$visible',
})<{ $visible: boolean }>(({ theme, $visible }) => ({
    position: 'absolute',
    zIndex: 1,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4, 2, 1),
    background: `linear-gradient(to bottom, transparent, ${theme.palette.background.paper})`,
    opacity: $visible ? 1 : 0,
    pointerEvents: 'none',
    transform: $visible ? 'translateY(0)' : 'translateY(4px)',
    transition: 'opacity 150ms ease, transform 150ms ease',
    visibility: $visible ? 'visible' : 'hidden',
}));

const ScrollHintLabel = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1),
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius * 4,
    boxShadow: theme.shadows[1],
}));

interface Props {
    visible: boolean;
    children: React.ReactNode;
}

export function ScrollHint({ visible, children }: Props) {
    return (
        <Hint $visible={visible}>
            <ScrollHintLabel>
                <Symbol symbol='keyboard_arrow_down' size='sm' />
                <Typography variant='caption'>{children}</Typography>
            </ScrollHintLabel>
        </Hint>
    );
}
